module.exports = __webpack_public_path__ + "static/img/preview-01.6a8afa1e.webp";